<template>
    <info-screen
            :title="title"
            :text="text"
            :action="sendCode"
            :button-text="$ml.get('sendCodeEnterCode')"
            :headerImg="6"
    >
        <a class="link" @click="back">{{changeText}}</a>
        <p class="errorLine" v-if="errorMessage">{{errorMessage}}</p>
        <template slot="bottomLink">
            <div class="callWrap">
                <a v-if="callEnabled"
                   class="enterCodeScreen_call"
                   @click.stop="sendCodeByCall"
                >{{$ml.get('enterCodeGetCall')}}</a>
           </div>
        </template>
    </info-screen>
</template>

<script>
    import InfoScreen from "../../components/layout/info-screen";
    import Profile from '../../helpers/profile'
    import {sendRegistationCode, getApiErrorMessage} from '../../helpers/api'

    export default {
        name: "sendCodePage",
        components: {
            InfoScreen},
        data() {
            return {
                changeText: '',
                title: '',
                text: '',
                errorMessage: '',
                timeoutShowError: null,
                isLoading: false,
            }
        },
        computed: {
            callEnabled: function () {
                return Profile.otptype !== 'email'
            }
        },
        created() {
            if (!Profile.registration)
                this.$router.replace({ name: 'LoginSendCode'});
        },
        mounted: function () {
            let typeStr;
            if (Profile.otptype === 'email') {
                typeStr = 'email';
                this.changeText = this.$ml.get('sendCodeChangeMail');
            } else {
                typeStr = this.$ml.get('sendCodePhone');
                this.changeText = this.$ml.get('sendCodeChangePhone');
            }
            this.title = Profile.username;
            this.text = this.$ml.with(typeStr).get('sendCodeForRegistrationText');
        },

        methods: {
            sendCode: function () {
                if (this.isLoading)
                    return;
                this.isLoading = true;
                sendRegistationCode(Profile.otptype).then(()=>{
                    this.$router.push({name: 'LoginEnterCode'});
                }, err => {
                    this.errorHandler(err)
                }).finally(()=>{
                    this.isLoading = false;
                });
            },

            sendCodeByCall: function () {
                if (this.isLoading)
                    return;
//                this.isLoading = true;
                sendRegistationCode('voip');//.then(()=>{
//                    this.$router.push({name: 'LoginEnterCode'});
//                    }
//                , err => {
//                    this.errorHandler(err)
//                }
//                ).finally(()=>{
//                    this.isLoading = false;
//                });
                this.$router.push({name: 'LoginEnterCode'});
            },

            errorHandler: function (err) {
                this.showNotValidMessage(getApiErrorMessage(err, {
                    '404': this.$ml.get(Profile.otptype === 'sms' ? 'enterLoginErrorPhone' : 'enterLoginErrorEmail')
                }));
            },

            showNotValidMessage: function (text) {
                this.errorMessage = text;
                clearTimeout(this.timeoutShowError);
                this.timeoutShowError = setTimeout(()=>{this.errorMessage = null}, 3000)
            },

            back: function () {
                this.$router.replace({name: 'LoginEnterLogin'});
            }
        }

    }
</script>

<style lang="scss" scoped>
    .link {
        color: #5CD69B;
        font-weight: 300;
        font-size: 16px;
        line-height: 19px;
        text-align: center;
        margin: 12px 0;
        display: inline-block;
    }

    .errorLine {
        font-size: 14px;
        color: #e53935;
    }
    .callWrap {
        text-align: center;
        padding-bottom: 10px;
    }
    .enterCodeScreen_call {
        cursor: pointer;
    }
</style>